// extracted by mini-css-extract-plugin
module.exports = {"modal":"ModalComponentPortal_modal__3xSlm","modal_content":"ModalComponentPortal_modal_content__3akjs"};